import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { AnimatedLogo } from "./AnimatedLogo";
import { useSite } from "../../context/SiteContext";
import { NAV } from "../../lib/constants";
import { telLink } from "../../lib/api";

export const Footer = () => {
  const { settings: s = {} } = useSite();
  return (
    <footer className="relative border-t-2 border-[#E5202A] bg-black" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 md:grid-cols-[auto_1fr_1fr]">
        <AnimatedLogo className="w-28" testId="footer-animated-logo" />
        <div>
          <h3 className="red-title text-2xl">{s.business_name}</h3>
          <p className="mt-3 max-w-sm text-sm text-slate-400">{s.tagline}</p>
          <ul className="mt-5 space-y-2 text-sm">
            {s.phone && <li><a href={telLink(s.phone)} className="flex items-center gap-2 hover:text-[#60A5FA]" data-testid="footer-phone-link"><Phone className="h-4 w-4 text-[#E5202A]" />{s.phone}</a></li>}
            {s.email && <li><a href={`mailto:${s.email}`} className="flex items-center gap-2 hover:text-[#60A5FA]" data-testid="footer-email-link"><Mail className="h-4 w-4 text-[#E5202A]" />{s.email}</a></li>}
            {s.location && <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#E5202A]" />{s.location}</li>}
            {s.hours && <li className="text-slate-400">{s.hours}</li>}
          </ul>
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="font-display text-base font-bold uppercase text-slate-300 hover:text-white" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>{n.label}</Link>
          ))}
          <Link to="/order" className="font-display text-base font-bold uppercase text-[#E5202A] hover:text-white" data-testid="footer-link-order">Start Order</Link>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {s.business_name}. Thank you for supporting local custom printing.
        <Link to="/admin" className="ml-3 text-slate-600 hover:text-slate-300" data-testid="footer-admin-link">Admin</Link>
      </div>
    </footer>
  );
};
